import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function HistoriqueModal({ open, handleClose }) {

  return (
    <Dialog open={open} onClose={handleClose}>
    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '600px' }}>
      <Typography variant="h6" sx={{ fontWeight: 400, mr: 3, textTransform:'uppercase'  }}>Historique des actions</Typography>
      <IconButton onClick={handleClose}><CloseIcon /></IconButton>
    </DialogTitle>
    <Divider />
    <DialogContent>
      <Typography variant="subtitle2" sx={{ fontSize: '17px', textAlign:'center' }}> Aucun résultat n'a été trouvé</Typography>
         </DialogContent>
    <Divider sx={{mb: 1}}/>
    <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
   

    </DialogActions>
  </Dialog>
  );
}
